import { PageOptionSelector } from "@/ExportableFile/Models/PageOptionSelector";
import { FormNavigation } from "@/Patient/Components/MedicalNote/ObstetricalFile/Navigation/FormNavigation";
import { FormPage } from "@/Patient/Components/MedicalNote/ObstetricalFile/Navigation/FormPage";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";
import { BritishColumbiaObstetricalFilePageIdEnum } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFilePageIdEnum";
import { ObstetricalFileVitalSign } from "@/Patient/Models/ObstetricalFile/ObstetricalFileVitalSign";
import { BritishColumbiaObstetricalFilePart1 } from "../BritishColumbia/Page/Part1/BritishColumbiaObstetricalFilePart1";
import { BritishColumbiaObstetricalFilePart2 } from "../BritishColumbia/Page/Part2/BritishColumbiaObstetricalFilePart2";
import { BritishColumbiaObstetricalFileResources } from "../BritishColumbia/Page/Resources/BritishColumbiaObstetricalFileResources";
import { IObstetricalFileProps, ObstetricalFile } from "../ObstetricalFile";
import { IObstetricalFilePageProps } from "../ObstetricalFilePage";

class BritishColumbiaObstetricalFile extends ObstetricalFile<BritishColumbiaObstetricalFileForm> {
    private readonly componentId = "british-columbia-obstetrical-file";
    protected obstetricalFileTypeCssClass = "british-columbia";

    protected getComponentId(): string {
        return this.componentId;
    }

    protected loadFormNavigation(props: IObstetricalFileProps): FormNavigation {
        const formsPages = [
            new FormPage({
                id: BritishColumbiaObstetricalFilePageIdEnum.Part1.toString(),
                name: cacheStore.GetString("ObstetricalFile_BritishColumbiaPart1Label"),
                render: () => <BritishColumbiaObstetricalFilePart1 {...this.buildFormProps()} />
            }),
            new FormPage({
                id: BritishColumbiaObstetricalFilePageIdEnum.Part2.toString(),
                name: cacheStore.GetString("ObstetricalFile_BritishColumbiaPart2Label"),
                render: () => <BritishColumbiaObstetricalFilePart2 {...this.buildFormProps()} />
            }),
            new FormPage({
                id: BritishColumbiaObstetricalFilePageIdEnum.Resources.toString(),
                name: cacheStore.GetString("ObstetricalFile_ResourcesLabel"),
                render: () => <BritishColumbiaObstetricalFileResources {...this.buildFormProps()} />
            })
        ];

        return new FormNavigation(formsPages, props.formDisplay.selectedPageId);
    }

    protected getSelectionPage(): any[] {
        return [
            new PageOptionSelector({
                label: `${cacheStore.GetString("ObstetricalFile_BritishColumbiaPart1Label")}`,
                value: 1,
                checked: true
            }),
            new PageOptionSelector({
                label: `${cacheStore.GetString("ObstetricalFile_BritishColumbiaPart2Label")}`,
                value: 3,
                checked: true
            }),
            new PageOptionSelector({
                label: `${cacheStore.GetString("ObstetricalFile_BritishColumbiaReferencePage1Label")}`,
                value: 2,
                checked: false
            }),
            new PageOptionSelector({
                label: `${cacheStore.GetString("ObstetricalFile_BritishColumbiaReferencePage2Label")}`,
                value: 4,
                checked: false
            }),
            new PageOptionSelector({
                label: `${cacheStore.GetString("PrivacyNoticePageLabel")}`,
                value: 5,
                checked: false
            })
        ];
    }

    protected getPageNumbers(): number[] {
        return [1, 2, 3, 4, 5];
    }

    private buildFormProps(): IObstetricalFilePageProps<BritishColumbiaObstetricalFileForm> {
        return {
            ...this.props,
            form: this.state.form,
            contributionCreationDate: this.props.model.ContributionCreationDate,
            previousObstetricalFile: this.props.previousObstetricalFile,
            contributionType: this.props.model.ContributionType,
            readonly: this.props.isReadOnly,
            onFormUpdate: (form: BritishColumbiaObstetricalFileForm) => super.handleFormUpdate(form),
            onObstetricalCountersUpdate: (form: BritishColumbiaObstetricalFileForm) => super.handleObstetricalCountersUpdate(form),
            onObstetricalFileVitalSignLink: (form: BritishColumbiaObstetricalFileForm, emrTemplateId: string) => super.handleObstetricalFileVitalSignLink(form, emrTemplateId),
            onMedicalItemVitalSignUpdate: async (vitalSign: ObstetricalFileVitalSign, emrTemplateId: string) => await super.handleVitalSignUpdate(vitalSign, emrTemplateId),
            onPageUnmount: () => this.onPageUnmount(),
            fetchLabObservations: this.props.fetchLabObservations
        };
    }
}

export { BritishColumbiaObstetricalFile };
